import React, {useEffect, useRef, useState} from "react";
import {convDate, dateConvert, dateStringConvert, isToday} from "../../Utils/ConvertDate";
import axios from "axios";
import {config} from "../../../Helpers/env";
import {errorMessages} from "../../../Helpers/ErrorMessages";
import {titleCase} from "../../Users/addUser";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Label from "../../Utils/FormInputs/Label";
import Col from "react-bootstrap/Col";
import TextField from "../../Utils/FormInputs/TextField";
import {ErrorMessage} from "../../Utils/styledComponents";
import {AutoCompleteUnControlled} from "../../Utils/FormInputs/AutoCompleteInput";
import SelectInput from "../../Utils/FormInputs/SelectInput";
import {ResizableTextarea} from "../../Utils/FormInputs/Textarea";
import {LoadingGif} from "../../Utils/Loader";
import {CollapsibleList, DataCell, ModuleTable} from "../../Utils/Lists/CollapsibleList";
import {IconButton, TableCell, TableRow, Tooltip} from "@material-ui/core";
import {StyledInput, StyledRemoveIcon} from "../../Inventory/stock/StockAdjustment";
import {StyledDiv} from "../../Visit/NewVisit/NewVisit";
import {FullScreenDialog} from "../../Utils/Dialogs/FullScreenDialog";


const headData = [
    {item: 'Batch Number', align: 'left', isRequired: true},
    {item: 'Expiry Date', align: 'center'},
    {item: 'Stock', align: 'right'},
    {item: 'Physical Stock', align: 'center', width: '120'},
    {item: 'Unit Cost', align: 'center'},
    {item: 'Action', align: 'right'}
];

function LabStockAdjustment({openAdjustment, setOpenAdjustment, isSubmitted, setIsSubmitted, actions}) {
    const [products, setProducts] = useState([]);
    const [product, setProduct] = useState({product_name: '', product_id: '', selected_product: ''})
    const [purchase_date, setPurchaseDate] = useState(dateConvert());
    const [submitted, setSubmitted] = useState(false);
    const [allStock, setAllStock] = useState([]);
    const [state, setState] = useState({reason: '', description: '', positive_reason: ''})
    const [loading, setLoading] = useState('idle');

    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const user_roles_id = _token.user_roles_id ? _token.user_roles_id : '';
    const adjusted_by = `${_token.first_name ? _token.first_name : ''} ${_token.last_name ? _token.last_name : ''}`

    const reasons = [{text: 'Wastage', value: 'Wastage'}, {text: 'Damage', value: 'Damage'}, {
        text: 'Expiry',
        value: 'Expiry'
    },
        {text: 'Drug change positive ', value: 'Drug change positive'}, {
            text: 'Drug change negative',
            value: 'Drug change negative'
        },
        {text: 'Positive adjustment for', value: 'Positive adjustment for'}, {
            text: 'Negative adjustment for',
            value: 'Negative adjustment for'
        },
        {value: 'Monthly stock take', text: 'Monthly stock take'}]

    const {product_id, selected_product, expiry_limit} = product;


    // get the batch ids for a specific product
    useEffect(() => {
        if (!product_id) {
            return
        }
        const formData = new FormData()
        formData.append('product_id', product_id)
        formData.append('location', 3)
        setLoading('loading')
        axios.post(`${config.smsUrl}/cinventory/retrieve_product_batch_ids`, formData).then(response => {
            const data = response.data;
            const dt = !data ? [] : data;
            const prod = dt.product ? dt.product : {};
            const arr = prod.product_batches_in_dispatch ? prod.product_batches_in_dispatch : []
            if (product_id && arr.length === 0) {
                const obj = {product_name: selected_product, product_id, open: true, batches: [], expiry_limit};
                products.unshift(obj);
                setProducts(products);
                setLoading('success');
            } else {
                const btches = arr.map((item) => (item['batch_id']));
                const params = {
                    product_id,
                    batches: btches,
                    location: 3
                };

                axios.post(`${config.smsUrl}/cinventory/retrieve_many_product_batch_ids`, params).then(res => {
                    const arr = res.data;
                    const batchData = arr.map(item => ({
                        ...item,
                        batch_id: item.batch_id ?? '',
                        expiry_date: item.expiry_date ?? '',
                        stock: item.total_product ?? 0,
                        physical_stock: '',
                        unit_cost: item.cost_price ?? '',
                        isBatch: true,
                    }));
                    const obj = {
                        product_name: selected_product,
                        product_id,
                        open: true,
                        batches: batchData,
                        expiry_limit
                    };
                    products.unshift(obj);
                    setProducts(products);
                    setLoading('success');
                }).catch(err => {
                    errorMessages(err, null, actions);
                    setLoading('error');
                });

            }

        }).catch(error => {
            errorMessages(error, null, actions)
            setLoading('error')
        });
    }, [product_id])

    const handleInput = event => {
        const {value} = event.target;
        setPurchaseDate(value);
    };

    const handleChange = (event) => {
        const {name, value} = event.target;
        setState({...state, [name]: value})
    }

    const handleRetrieveDrugs = (event) => {
        const val = event.target ? event.target.value : event;
        setProduct({...product, product_name: val})
        let tmp = val.trim();
        if (tmp !== '') {
            const formData = new FormData();
            formData.append('product_name', titleCase(tmp));
            axios.post(`${config.smsUrl}/cdoctor/autocomplete_search_medicine`, formData).then(response => {
                const drugs = response.data;
                const dt = !drugs ? [] : drugs;
                setAllStock(dt)
            }).catch(error => {
                errorMessages(error, null, actions)
            });
        }
    };

    const handleClickDrug = (event) => {
        setProduct({
            product_id: event.value,
            product_name: '',
            selected_product: event.innerText,
            expiry_limit: event.expiry_limit
        });
    };

    const handleSubmit = event => {
        event.preventDefault();
        setSubmitted(true);
        const {reason, description, positive_reason} = state;
        let check_batch_stock = false;
        const rows = products.filter((it) => {
            return it.batches.length > 0;
        }).map((item) => {

            const batch_array = item.batches.map((ex) => {

                if (check_batch_stock === false && !ex.physical_stock) {
                    check_batch_stock = true;
                }

                return {
                    batch_id: ex.batch_id,
                    expiry_date: convDate(ex.expiry_date),
                    stock: ex.stock,
                    physical_stock: parseInt(ex.physical_stock),
                    unit_cost: ex.unit_cost
                }
            });

            return {
                product_id: item.product_id,
                batches: batch_array
            }
        });
        const data = rows.filter(item => item.product_id).reduce((r, a) => r.concat(a.batches.map(({...b}) => ({
            product_id:
            a.product_id, ...b
        }))), []);

        const isPositiveAdjustment = reason.toLowerCase().includes('positive')
        const isNegativeAdjustment = reason.toLowerCase().includes('negative')
        const isPositiveQuantity = isPositiveAdjustment && data.some(row => row.physical_stock >= row.stock)
        const isNegativeQuantity = !isPositiveAdjustment && data.some(row => row.physical_stock <= row.stock)


        let dt = {
            user_roles_id,
            reason: `${reason} ${positive_reason}`,
            description,
            date: purchase_date,
            details: data,
            location: 'lab',
            adjustment_type: isPositiveAdjustment ? 'I' : isNegativeAdjustment ? 'D' : ''
        };


        const selected_purchase_date = isToday(purchase_date)

        if (reason && (check_batch_stock === false) && (isNegativeQuantity || isPositiveQuantity) && selected_purchase_date) {
            setIsSubmitted('pending')
            axios.post(`${config.smsUrl}/cinventory/stock_adjustment`, dt)
                .then(() => {
                    actions.snackbarActions.snackSuccess('Stock adjusted Successfully');
                    setOpenAdjustment(false)
                    setLoading('idle');
                    setProducts([]);
                    setProduct({product_name: '', product_id: '', selected_product: ''});
                    setSubmitted(false)
                    setIsSubmitted('resolved')
                }).catch(err => {
                errorMessages(err, null, actions)
                setIsSubmitted('rejected')
            })
        }
    };


    const handleRemoveProduct = (index) => {
        const arr = products.filter((_, idx) => (index !== idx));
        setProducts(arr);
        setLoading('idle');
    }

    const handleChangeItem = (event, product_index, batch_index) => {
        const {name, value} = event.target;
        const arr = products.map((item, index) => {
            if (index === product_index) {
                const arr = item.batches.map((batch, batch_idx) => {
                    if (batch_index === batch_idx) {
                        return {...batch, [name]: value}
                    }
                    return batch
                })
                return {...item, batches: arr}
            }
            return item
        })
        setProducts(arr)
    }

    const handleOpen = (idx) => {
        const itemsArr = products.map((item, index) => {
            if (index === idx) {
                return {...item, open: !item.open}
            } else {
                return item
            }
        })
        setProducts(itemsArr)
    }

    const handleRemoveBatch = (idx, batch_idx) => {
        const arr = products.map((item, index) => {
            if (index === idx) {
                const arr = item.batches.filter((_, batch_index) => batch_index !== batch_idx);
                return {...item, batches: arr}
            }
            return item;
        });
        setProducts(arr);
    }

    const isPending = isSubmitted === 'pending';

    const isLoading = loading === 'loading';
    const isSuccess = loading === 'success';
    const isError = loading === 'error';


    const {reason, description, positive_reason} = state;

    const productLength = products.some(item => item.batches.length > 0);

    const isPositive = reason.includes('Positive') || reason.includes('Negative')
    const isPositiveAdjustment = reason.toLowerCase().includes('positive')


    const today = dateConvert()
    const selected_date = isToday(purchase_date)

    return (
        <FullScreenDialog open={openAdjustment} handleClose={() => setOpenAdjustment(false)} title='Adjust Stock'>
            <form onSubmit={handleSubmit} autoComplete="off">
                <StyledDiv>
                    <Form.Group as={Row}>
                        <Label column sm="3" name='Date' htmlFor='adjustment_date'/>
                        <Col sm="8">
                            <TextField name="purchase_date" value={purchase_date} type="date" id='adjustment_date'
                                       onChange={handleInput} min={today} max={today}
                            />
                            {!selected_date ? <ErrorMessage>Enter current date</ErrorMessage> : null}
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                        <Label column sm="3" name=' Adjusted by' htmlFor='adjustedBy'/>
                        <Col sm="8">
                            <TextField value={adjusted_by} type="text" readOnly id='adjustedBy'/>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                        <Label type name='Product' column sm='3' htmlFor='product'/>
                        <Col sm='8'>
                            <AutoCompleteUnControlled options={allStock} handleChange={handleRetrieveDrugs}
                                                      label_text="label" isExpiryLimit={true}
                                                      medicine_value={{
                                                          label: product.product_name,
                                                          value: product.product_id
                                                      }} testId="product_name" id="product_name" value_text="value"
                                                      handleProductData={handleClickDrug}
                                                      placeholder="Type Product Name"
                                                      errorMsg="Enter Product Name"/>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                        <Label column sm="3" name='Reason' htmlFor='reason' type/>
                        <Col sm="8">
                            <SelectInput defaultOption="Select reason..." value={reason} options={reasons}
                                         submitted={submitted}
                                         type="text" name="reason" id='reason' onChange={handleChange}
                                         errorMsg="Reason is required"/>
                        </Col>
                    </Form.Group>

                    {isPositive ? <Form.Group as={Row}>
                        <Label column sm="3" name={reason} htmlFor='positive_reason'/>
                        <Col sm="8">
                            <ResizableTextarea value={positive_reason} placeholder={`Write ${reason?.toLowerCase()}...`}
                                               name="positive_reason" id='positive_reason'
                                               onChange={handleChange} rows={2}/>
                        </Col>
                    </Form.Group> : null}

                    <Form.Group as={Row}>
                        <Label column sm="3" name='Description' htmlFor='description'/>
                        <Col sm="8">
                            <ResizableTextarea value={description} type="text" name="description" id='description'
                                               onChange={handleChange} rows={3}/>
                        </Col>
                    </Form.Group>

                </StyledDiv>
                {isLoading ? <div className='text-center'><LoadingGif/></div> : null}
                {isSuccess ? productLength ? products && products.map((item, index) => {
                    const batches = item.batches ? item.batches : [];
                    return (
                        batches.length > 0 ?
                            <CollapsibleList key={index} open={item.open} name={item.product_name}
                                             handleOpen={() => handleOpen(index)} button={
                                <>
                                    <Tooltip title='Delete'>
                                        <IconButton onClick={() => handleRemoveProduct(index)}>
                                            <StyledRemoveIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </>
                            }>
                                <ModuleTable headData={headData}>
                                    {batches.map((row, idx) => {
                                        const daysLeft = Math.floor((Date.parse(row.expiry_date) - Date.now()) / (24 * 60 * 60 * 1000));
                                        const isPositiveQuantity = isPositiveAdjustment && parseInt(row.physical_stock) < row.stock
                                        const isNegativeQuantity = !isPositiveAdjustment && parseInt(row.physical_stock) > row.stock
                                        return (
                                            <TableRow
                                                key={idx}
                                            >
                                                <DataCell align='left'>
                                                    {
                                                        row.isBatch ? row.batch_id :
                                                            <>
                                                                <StyledInput submitted={submitted}
                                                                             onChange={e => handleChangeItem(e, index, idx)}
                                                                             value={row.batch_id} name='batch_id'
                                                                             type='text' width='50%'/>
                                                                {(submitted && !row.batch_id) &&
                                                                    <div className="invalid-text">Batch id is
                                                                        required</div>}
                                                            </>

                                                    }
                                                </DataCell>
                                                <DataCell align='left' width='200'>
                                                    {
                                                        row.isBatch ? dateStringConvert(row.expiry_date) :
                                                            <>
                                                                <StyledInput submitted={submitted}
                                                                             disabled={row.disableExpiry}
                                                                             onChange={e => handleChangeItem(e, index, idx)}
                                                                             value={row.expiry_date} type='date'
                                                                             name='expiry_date' width='100%'/>
                                                                {(submitted && !row.expiry_date) ?
                                                                    <div className="invalid-text">Expiry date is
                                                                        required</div> :
                                                                    item.expiry_limit > daysLeft ?
                                                                        <div className="invalid-text">This batch is
                                                                            within
                                                                            the product's expiry limit</div> : null}
                                                            </>

                                                    }

                                                </DataCell>
                                                <TableCell align='left'>{row.stock}</TableCell>
                                                <DataCell align='left' width='15%'>
                                                    <StyledInput submitted={submitted && !row.physical_stock}
                                                                 onChange={e => handleChangeItem(e, index, idx)}
                                                                 value={row.physical_stock} name='physical_stock'
                                                                 type='number' min="0"/>
                                                    {(submitted && !row.physical_stock) &&
                                                        <ErrorMessage>Physical stock is required</ErrorMessage>}
                                                    {reason && row.physical_stock && isPositiveQuantity ?
                                                        <ErrorMessage>Physical stock should be more than stock for a
                                                            positive adjustment</ErrorMessage> : null}
                                                    {reason && row.physical_stock && isNegativeQuantity ?
                                                        <ErrorMessage>Physical stock should be less than stock for a
                                                            negative adjustment</ErrorMessage> : null}
                                                </DataCell>
                                                <DataCell align='left'>
                                                    {
                                                        row.isBatch ? row.unit_cost :
                                                            <>
                                                                <StyledInput submitted={submitted}
                                                                             onChange={e => handleChangeItem(e, index, idx)}
                                                                             value={row.unit_cost} name='unit_cost'
                                                                             type='number' width='40%' min="0"/>
                                                                {(submitted && !row.unit_cost) &&
                                                                    <div className="invalid-text">Unit cost is
                                                                        required</div>}
                                                            </>

                                                    }

                                                </DataCell>
                                                <DataCell align='left'>
                                                    <Tooltip title='Delete'>
                                                        <IconButton onClick={() => handleRemoveBatch(index, idx)}>
                                                            <StyledRemoveIcon/>
                                                        </IconButton>
                                                    </Tooltip>
                                                </DataCell>
                                            </TableRow>
                                        )
                                    })}
                                </ModuleTable>
                            </CollapsibleList> : null
                    )
                }) : <p className='text-center mt-2'>There are no batches for this product, please purchase product
                    first</p> : null}
                {isError ? <div className='text-center'>The server did not return a valid response</div> : null}
                {productLength ?
                    <div className='text-right'>
                        <button type='submit' disabled={isPending} className='btn btn-sm sms-info-btn'
                                onClick={handleSubmit}>{isPending ? 'Submitting....' : 'Submit'}</button>
                    </div> : null
                }
            </form>
        </FullScreenDialog>
    )
}
export default LabStockAdjustment